export function getServerData(name: string, defaultValue?: any): any {
  const serverData =
    typeof window !== 'undefined' ? window?.SERVER_DATA : undefined;

  return (serverData && serverData[name]) || defaultValue;
}
